import AxiosAPI from "./AxiosAPI";
export const fetchRegistration= async (registrationId) => {
    try {
        const response = await AxiosAPI.post(`/getregistration`,registrationId);
        return response.data;
    } catch (err) {
        return err?.response?.data || err.message || err;
    }
};

export const createRegistration = async (registrationData) => {
  try {
    const response = await AxiosAPI.post(`/registration`, registrationData, {
      headers: { "Content-Type": "application/json" }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const handleEditRegistration = async (id, data) => {
  console.log("Editing registration with ID:", id);
  console.log("Sending data with state:", data.state);
  
  try {
    const response = await AxiosAPI.put(`/registration/${id}`, data, {
      headers: { "Content-Type": "application/json" }
    });
    console.log("API response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error in handleEditRegistration:", error);
    // Return an error object with code instead of throwing to prevent UI blocking
    return {
      code: "1",
      message: error.response?.data?.message || error.message || "Error updating registration"
    };
  }
};



export const fetchInventoryIssues = async () => {
  try {
    const response = await AxiosAPI.get(`/getinventoryissue`);
    return response.data;
  } catch (error) {
    return error.response?.data || { code: "1", message: error.message || "Error fetching inventory issues" };
  }
};



export const fetchRegistrationAuditTrail = async (key) => {
  try {
    const response = await AxiosAPI.get(`/registration/audittrails?key=${key}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};


